import { GetterTree } from 'vuex';
import { NavState } from './types';
import { StoreState } from '@/types';

const navGetters: GetterTree<NavState, StoreState> = {
  state: (state) => state.state,

  dialogs: (state) => state.dialogs,

  defaultView: (state, getters, rootState, rootGetters) => {
    const perms = rootGetters['auth/permissions'];
    // if(perms.approval)return 'sales view'
    // if(perms.shippingagent)return 'shipping view'
    if (perms.salesagent) {return 'sales view'; }
    return 'sales view';
  }
};

export default navGetters;
